import React from "react";
import {Route, Redirect} from "react-router-dom";
import {Content} from "./Content";
import { shallowEqual, useSelector } from "react-redux";

export function ContentRoute({ children, component, render, path, permission, ...props }) {
  const {permissions} = useSelector(
    ({auth}) => ({
      permissions: auth.permissions,
    }),
    shallowEqual
  );

  if (!permissions?.some(item => item.name === permission) && permission) {
    return (
      <Redirect from={path} to="/error/unauthorized"/>
    );
  }

  return (
    <Route {...props}>
      {routeProps => {
        if (typeof children === "function") {
          return <Content>{children(routeProps)}</Content>;
        }

        if (!routeProps.match) {
          return null;
        }

        if (children) {
          return <Content>{children}</Content>;
        }

        if (component) {
          return (
            <Content>{React.createElement(component, routeProps)}</Content>
          );
        }

        if (render) {
          return <Content>{render(routeProps)}</Content>;
        }

        return null;
      }}
    </Route>
  );
}
